import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BatteryHalfIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M19.3333 6.95C20.0708 6.95 20.6667 7.53094 20.6667 8.25V14.75C20.6667 15.4691 20.0708 16.05 19.3333 16.05H3.33333C2.59583 16.05 2 15.4691 2 14.75V8.25C2 7.53094 2.59583 6.95 3.33333 6.95H19.3333ZM3.33333 5C1.49167 5 0 6.45437 0 8.25V14.75C0 16.5456 1.49167 18 3.33333 18H19.3333C21.175 18 22.6667 16.5456 22.6667 14.75V14.1C23.4042 14.1 24 13.5191 24 12.8V10.2C24 9.48094 23.4042 8.9 22.6667 8.9V8.25C22.6667 6.45437 21.175 5 19.3333 5H3.33333ZM12 8.9H4V14.1H12V8.9Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default BatteryHalfIcon
